interface IConfig {
  account_id?: string;
}

declare const CONFIG: IConfig;

export const ACCOUNT_ID = CONFIG.account_id;
